import styled from 'styled-components';
import InputRating from '@/trio-ui/InputRating';

const dividerStyles = (color: string): string => `
  border-top: 1px solid ${color};
  padding-top: 24px;
`;

export const Box = styled.div<{ isReviewed: boolean }>`
  margin-bottom: 24px;
  ${(prop) => !prop.isReviewed && dividerStyles(prop.theme.colors['neutral-30'])}
`;

export const ReviewInfos = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

export const ReviewerName = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: ${(prop) => prop.theme.colors['neutral-90']};
  margin-right: 8px;
`;

export const ReviewTime = styled.span`
  font-size: 10px;
  line-height: 140%;
  color: ${(prop) => prop.theme.colors['neutral-90']};
`;

export const InputsBox = styled.div`
  margin-top: 12px;
  border: 1px solid ${(prop) => prop.theme.colors['neutral-40']};
  border-radius: 4px;
`;

export const InputsRow = styled.div`
  display: grid;
  padding: 15px;
  grid-template-columns: 1fr;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const InputWrapper = styled.div<{ inputListSize: number }>``;

export const CustomInputRating = styled(InputRating)`
  align-items: flex-start;
  display: flex;
  & > label {
    text-align: start;
    justify-content: end;
    text-align: right;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      flex: 2;
    }
  }
  & > div {
    position: relative;
    top: -2px;
  }
`;

export const ScoreBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  gap: 12px;
  height: 37px;
  background: ${(prop) => prop.theme.colors['neutral-20']};
  border-top: 1px solid ${(prop) => prop.theme.colors['neutral-40']};

  font-weight: 600;
  font-size: 14px;
  line-height: 150%;

  color: ${(prop) => prop.theme.colors['neutral-70']};

  span {
    color: ${(prop) => prop.theme.colors['primary-60']};
  }
`;

export const ButtonsBox = styled.div`
  display: flex;
  margin-top: 12px;
  gap: 4px;
`;
